<template>
    <modal :show.sync="showModal" >
      <delete-project :project.sync="projectToDelete"></delete-project>
    </modal>
  
    <modal :show.sync="showModalProjects" >
      <delete-projects :projects="projectsToDelete"></delete-projects>
    </modal>

    <div class="card card-content">
        <div class="card-header">
            <div class="header">
                <!-- <breadcrumb></breadcrumb> -->
                <div class="breadcrumb">
                  <a class="breadcrumb-item" v-link="{ path: '/'}">Accueil</a>
                  <a class="breadcrumb-item" v-link="{ path: '/project/list'}">Gestion des parcours</a>
                </div>
                <h1>Parcours</h1>
            </div>
            <div class="actions">
                <a class="btn btn-link" v-link="{ path: '/project/add'}" >Ajouter un nouveau parcours</a>
            </div>
        </div>
        <table class="table table-hover table-widget">
            <thead>
                <tr>
                    <td colspan="2">
                        <select v-model="rowPerPage" class="form-control">
                            <option value="10">10 lignes</option>
                            <option value="100">100 lignes</option>
                            <option value="500">500 lignes</option>
                        </select>
                    </td>
                    <td colspan="3" class="text-xs-right">{{ projects.length }} parcours enregistrés</td>
                </tr>
                <tr>
                    <td colspan="4">
                        <button class="btn btn-link btn-sm" v-on:click="selectAll">Selectionner tout</button>
                        <button class="btn btn-link btn-sm" v-on:click="selectVisible">Selectionner visible</button>
                        <button class="btn btn-link btn-sm" v-on:click="unselect" v-if="selected.length">Déselectionner</button>
                        <span class="btn btn-sm">{{ selected.length }} sélectionnés</span>
                    </td>
                    <td>
                        <div class="form-inline" style="text-align: right;display:none;">
                            <select name="" id="actionsList" class="form-control form-control-sm" v-model="bulk_action">
                                <option value="none">Action</option>
                                <option value="delete">Supprimer</option>
                            </select>
                            <button class="btn btn-primary btn-sm" v-if="active_bulk_action" v-on:click="executeBulkAction">Executer</button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th></th>
                    <th @click="sort('name')">Parcours&nbsp;<span :class="getClass('name')"></span></th>
                    <th @click="sort('contact_lastname')">Nom&nbsp;<span :class="getClass('contact_lastname')"></span></th>
                    <th @click="sort('contact_firstname')">Prénom&nbsp;<span :class="getClass('contact_firstname')"></span></th>
                    <th width="250px">&nbsp;</th>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                    <td>
                        <select class="form-control" v-model="filter_name">
                            <option value=""></option>
                            <option value="ACA">ACA</option>
							<option value="AUTRE">AUTRE</option>
                            <option value="CAE">CAE</option>
							<option value="CLUB">CLUB</option>
                            <option value="COUVEUSE">COUVEUSE</option>
							<option value="COUVEUSE MOSSON">COUVEUSE MOSSON</option>
                            <option value="FORMATION AUTRES">FORMATION AUTRES</option>
							<option value="FORMATION CERTIFIANTE">FORMATION CERTIFIANTE</option>
							<option value="REGION">REGION</option>
              <option value="PEPITE">PEPITE</option>
                        </select>
                    </td>
                    <td><input type="text" class="form-control" v-model="filter_contact_lastname"></td>
                    <td><input type="text" class="form-control" v-model="filter_contact_firstname"></td>
                    <td>&nbsp;</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(index, project) of page" v-on:click="preview(project)" v-bind:class="{active: isActive(project)}">
                    <td><input type="checkbox" value="{{ project.id }}" v-model="selected"></td>
                    <td>{{ projectName(project) }}</td>
                    <td>{{ project.contact_lastname }}</td>
                    <td>{{ project.contact_firstname }}</td>
                    <!-- <td>{{ correctDate(project.first_meeting_date) }} / {{ correctDate(project.exit_date) }}</td> -->
                    <td class="text-xs-right">
                        <button class="btn btn-primary" v-link="{ name: 'editProject', params: { projectId: project.id }}">Editer</button>
                        <button class="btn btn-warning" @click="modalDelete(project)">Supprimer</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="text-xs-center">
            <pagination :records="row" :row-per-page="rowPerPage"></pagination>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    // Components
    import Modal from '../modals/Modal.vue'
    import DeleteProject from '../modals/DeleteProject.vue'
    import DeleteProjects from '../modals/DeleteProjects.vue'
    import Pagination from '../grid/Pagination.vue'
    import Breadcrumb from '../nav/Breadcrumb.vue'

    import { projects } from '../../vuex/getters'
    import { getProjects } from '../../vuex/actions/projectActions'

    export default{
      vuex: {
        getters: { projects },
        actions: { getProjects }
      },
      data () {
        return {
          orderType: '',
          orderAsc: -1,
          showModal: false,
          projectToDelete: null,
          showModalProjects: false,
          projectsToDelete: null,
          rowPerPage: 10,
          page: [],
          filter_name: '',
          filter_contact_lastname: '',
          filter_contact_firstname: '',
          row: [],
          selected: [],
          bulk_action: 'none',
          active_bulk_action: false,
          active: {}
        }
      },
      watch: {
        filter_name: function () {
          this.filter()
        },
        filter_contact_lastname: function () {
          this.filter()
        },
        filter_contact_firstname: function () {
          this.filter()
        },
        row: function () {
          this.page = this.row.slice(0, this.rowPerPage)
        },
        rowPerPage: function () {
          this.page = this.row.slice(0, this.rowPerPage)
        },
        projects: function () {
          // this.updateProjectsName()
          this.row = Array.from(this.projects)
          this.orderType = ''
          this.sort('contact_lastname')
        },
        bulk_action: function () {
          this.active_bulk_action = (this.bulk_action !== 'none' && this.selected.length > 0)
        },
        selected: function () {
          this.active_bulk_action = (this.bulk_action !== 'none' && this.selected.length > 0)
        }
      },
      methods: {
        getClass (property) {
          if (this.orderType === property) {
            if (this.orderAsc === -1) {
              return 'icon-sort-asc'
            }
            return 'icon-sort-desc'
          }
          return 'icon-unsorted'
        },
        sort (filter) {
          if (this.orderType === filter) {
            this.orderAsc = this.orderAsc * -1
            this.row.reverse()
          } else {
            this.orderType = filter
            this.row.sort(function (a, b) {
              if (a[filter] < b[filter]) return -1
              if (a[filter] > b[filter]) return 1
              return 0
            })
          }
        },
        filter () {
          let row = Array.from(this.projects)

          row = this.filterElement('name', this.filter_name, row)
          row = this.filterElement('contact_lastname', this.filter_contact_lastname, row)
          row = this.filterElement('contact_firstname', this.filter_contact_firstname, row)

          this.row = row
        },
        filterElement (filter, text, row) {
          // console.log('texte |' + text + '|')
          let search = new RegExp('^' + text, 'i')
          let search2 = new RegExp('^ ' + text, 'i')
          row = row.filter(function (project) {
            if (filter !== null && filter !== undefined && typeof filter === 'string') {
              // console.log('projectfilter #' + filter + '# : #' + project[filter] + '# for #' + search + '#')
              if (text === '') return true
              else {
                // console.log(filter + ' for ' + search + ' dans #' + project[filter] + '# : ' + project[filter].search(search) + ' | ' + project[filter].search(search2))
                if (project[filter].search(search) !== -1) {
                  return true
                } else if (project[filter].search(search2) !== -1) {
                  return true
                } else {
                  return false
                }
                // return (project[filter].search(search) !== -1)
              }
            }
          })

          return row
        },
        add () {
          this.addProject()
        },
        modalDelete (project) {
          this.projectToDelete = project
          this.showModal = true
        },
        preview (project) {
          this.active = project
          let data = [
            { label: 'Parcours', value: project.name },
            { label: 'Nom', value: project.contact_lastname },
            { label: 'Prenom', value: project.contact_firstname },
            { label: '1er RDV', value: moment(project.first_meeting_date, 'YYYY-MM-DD').format('DD-MM-YYYY') === 'Invalid date' ? '' : moment(project.first_meeting_date, 'YYYY-MM-DD').format('DD-MM-YYYY') },
            { label: 'Sortie', value: moment(project.exit_date, 'YYYY-MM-DD').format('DD-MM-YYYY') === 'Invalid date' ? '' : moment(project.exit_date, 'YYYY-MM-DD').format('DD-MM-YYYY') }
          ]
          this.$dispatch('preview-data', data)
        },
        isActive: function (project) {
          return this.active === project
        },
        selectAll () {
          let selected = []
          this.row.forEach(function (project) {
            selected.push(project.id.toString())
          })

          this.selected = selected
        },
        selectVisible () {
          let selected = []
          this.page.forEach(function (project) {
            selected.push(project.id.toString())
          })

          this.selected = selected
        },
        unselect () {
          this.selected = []
        },
        executeBulkAction () {
          let that = this
          let projectToDelete = this.projects.filter(function (project) {
            return that.selected.indexOf(project.id.toString()) !== -1
          })

          switch (this.bulk_action) {
            case 'delete':
              this.projectsToDelete = projectToDelete
              this.showModalProjects = true
              break
          }
        },
        projectName: function (project) {
          // console.log('createName #' + project.name + '# #' + project.project_type_id + '# #' + project.id + '#')
          /* if (project.name === 1 || project.name === '1') {
            return 'ACA'
          } else if (project.name === 2 || project.name === '2') {
            return 'REGION'
          } else if (project.name === 3 || project.name === '3') {
            return 'COUVEUSE'
          } else if (project.name === 4 || project.name === '4') {
            return 'COUVEUSE MOSSON'
          } else if (project.name === 5 || project.name === '5') {
            return 'FORMATION CERTIFIANTE'
          } else if (project.name === 6 || project.name === '6') {
            return 'FORMATION AUTRES'
          } else if (project.name === 7 || project.name === '7') {
            return 'CLUB'
          } else if (project.name === 8 || project.name === '8') {
            return 'CAE'
          } else if (project.name === 9 || project.name === '9') {
            return 'PEPITE'
          } else if (project.name === 1000 || project.name === '1000') {
            return 'AUTRE'
          } else if (project.name === 'ACA' || project.name === 'REGION' || project.name === 'COUVEUSE' || project.name === 'COUVEUSE MOSSON' || project.name === 'FORMATION CERTIFIANTE' || project.name === 'FORMATION AUTRES' || project.name === 'CLUB' || project.name === 'CAE' || project.name === 'PEPITE' || project.name === 'AUTRE') {
            return project.name
          } else */
          if (project.project_type_id === '1' || project.project_type_id === 1) {
            return 'ACA'
          } else if (project.project_type_id === '2' || project.project_type_id === 2) {
            return 'REGION'
          } else if (project.project_type_id === '3' || project.project_type_id === 3) {
            return 'COUVEUSE'
          } else if (project.project_type_id === '4' || project.project_type_id === 4) {
            return 'COUVEUSE MOSSON'
          } else if (project.project_type_id === '5' || project.project_type_id === 5) {
            return 'FORMATION CERTIFIANTE'
          } else if (project.project_type_id === '6' || project.project_type_id === 6) {
            return 'FORMATION AUTRES'
          } else if (project.project_type_id === '7' || project.project_type_id === 7) {
            return 'CLUB'
          } else if (project.project_type_id === '8' || project.project_type_id === 8) {
            return 'CAE'
          } else if (project.project_type_id === '9' || project.project_type_id === 9) {
            return 'PEPITE'
          } else if (project.project_type_id === '1000' || project.project_type_id === 1000) {
            return 'AUTRE'
          }
        },
        correctDate: function (date) {
          date = moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')
          if (date === 'Invalid date') {
            date = ''
          }
          return date
        },
        updateProjectsDate () {
          this.projects.forEach(function (project) {
            project.first_meeting_date = moment(project.first_meeting_date, 'YYYY-MM-DD').format('DD-MM-YYYY')
            project.exit_date = moment(project.exit_date, 'YYYY-MM-DD').format('DD-MM-YYYY')
          })
        },
        updateProjectsName () {
          this.projects.forEach(function (project) {
            // console.log('updateProjectsName ' + project.name + ' ' + project.project_type_id)
            if (project.project_type_id === '1' || project.project_type_id === 1) {
              project.name = 'ACA'
            } else if (project.project_type_id === '2' || project.project_type_id === 2) {
              project.name = 'REGION'
            } else if (project.project_type_id === '3' || project.project_type_id === 3) {
              project.name = 'COUVEUSE'
            } else if (project.project_type_id === '4' || project.project_type_id === 4) {
              project.name = 'COUVEUSE MOSSON'
            } else if (project.project_type_id === '5' || project.project_type_id === 5) {
              project.name = 'FORMATION CERTIFIANTE'
            } else if (project.project_type_id === '6' || project.project_type_id === 6) {
              project.name = 'FORMATION AUTRES'
            } else if (project.project_type_id === '7' || project.project_type_id === 7) {
              project.name = 'CLUB'
            } else if (project.project_type_id === '8' || project.project_type_id === 8) {
              project.name = 'CAE'
            } else if (project.project_type_id === '9' || project.project_type_id === 9) {
              project.name = 'PEPITE'
            } else if (project.project_type_id === '1000' || project.project_type_id === 1000) {
              project.name = 'AUTRE'
            }
          })
        }
      },
      components: {
        Modal,
        DeleteProject,
        DeleteProjects,
        Pagination,
        Breadcrumb
      },
      events: {
        'deleteProject': function () {
          console.log('DELETE')
          if (this.projectToDelete) {
            this.deleteProject(this.projectToDelete)
            this.projectToDelete = null
          }
        },
        'after-delete-projects': function () {
          this.projectsToDelete = null
          this.selected = []
        },
        'change-page': function (index) {
          let start = (index - 1) * this.rowPerPage
          this.page = this.row.slice(start, start + this.rowPerPage)
        }
      },
      computed: {
        name: function () {
          if (!Array.isArray(this.project)) {
            let nameReturned
            console.log('computed ' + this.project.name + ' ' + this.project.project_type_id)
            if (this.project.project_type_id === '1' || this.project.project_type_id === 1) {
              nameReturned = 'ACA ' + this.project.name
            } else if (this.project.project_type_id === '2' || this.project.project_type_id === 2) {
              nameReturned = 'REGION ' + this.project.name
            } else if (this.project.project_type_id === '3' || this.project.project_type_id === 3) {
              nameReturned = 'COUVEUSE ' + this.project.name
            } else if (this.project.project_type_id === '4' || this.project.project_type_id === 4) {
              nameReturned = 'COUVEUSE MOSSON ' + this.project.name
            } else if (this.project.project_type_id === '5' || this.project.project_type_id === 5) {
              nameReturned = 'FORMATION CERTIFIANTE ' + this.project.name
            } else if (this.project.project_type_id === '6' || this.project.project_type_id === 6) {
              nameReturned = 'FORMATION AUTRES ' + this.project.name
            } else if (this.project.project_type_id === '7' || this.project.project_type_id === 7) {
              nameReturned = 'CLUB ' + this.project.name
            } else if (this.project.project_type_id === '8' || this.project.project_type_id === 8) {
              nameReturned = 'CAE ' + this.project.name
            } else if (this.project.project_type_id === '9' || this.project.project_type_id === 9) {
              nameReturned = 'PEPITE ' + this.project.name
            } else if (this.project.project_type_id === '1000' || this.project.project_type_id === 1000) {
              nameReturned = 'AUTRE ' + this.project.name
            }
            return nameReturned
          }
        }
      },
      ready () {
        // this.getProjectTypes()
        this.getProjects()
      }
    }
</script>



// WEBPACK FOOTER //
// ProjectsList.vue?1d10aeb2